import React, { useState } from 'react';

const QuickServiceForm = ({ onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    description: '',
    base_price: '',
    duration_minutes: '',
    labor_included: true
  });

  const [errors, setErrors] = useState({});

  const categories = [
    'Hébergement',
    'Maintenance',
    'SEO',
    'SEA',
    'Rédaction',
    'Design',
    'Développement',
    'Formation',
    'Licence'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Le nom de la prestation est requis';
    if (!formData.category) newErrors.category = 'La catégorie est requise';
    if (!formData.base_price || isNaN(parseFloat(formData.base_price)) || parseFloat(formData.base_price) < 0) newErrors.base_price = 'Le prix doit être un nombre positif';
    if (formData.duration_minutes && (isNaN(parseInt(formData.duration_minutes)) || parseInt(formData.duration_minutes) < 0)) newErrors.duration_minutes = 'La durée doit être un nombre positif en minutes';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const allowedCategories = ['Entretien','Réparation','Diagnostic','Carrosserie','Pneumatiques','Climatisation','Électronique'];
      const serviceData = {
        ...formData,
        base_price: parseFloat(formData.base_price),
        duration_minutes: formData.duration_minutes ? parseInt(formData.duration_minutes) : null,
        active: true
      };
      if (!allowedCategories.includes(formData.category)) {
        delete serviceData.category;
      }
      await onSubmit(serviceData);
    } catch (error) {
      console.error('Erreur lors de la création de la prestation:', error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content quick-service-modal">
        <div className="modal-header">
          <h3>Nouvelle Prestation Rapide</h3>
          <button className="close-btn" onClick={onCancel} type="button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="quick-service-form">
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="name">Nom de la prestation *</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className={errors.name ? 'error' : ''} placeholder="Ex: Audit SEO, Maintenance WordPress, Campagne SEA..." autoFocus />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="category">Catégorie *</label>
              <select id="category" name="category" value={formData.category} onChange={handleChange} className={errors.category ? 'error' : ''}>
                <option value="">Sélectionner une catégorie</option>
                {categories.map(category => (<option key={category} value={category}>{category}</option>))}
              </select>
              {errors.category && <span className="error-message">{errors.category}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="base_price">Tarif de base (€) *</label>
              <input type="number" step="0.01" id="base_price" name="base_price" value={formData.base_price} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="decimal" className={errors.base_price ? 'error' : ''} placeholder="0.00" min="0" />
              {errors.base_price && <span className="error-message">{errors.base_price}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="duration_minutes">Durée estimée (minutes)</label>
              <input type="number" id="duration_minutes" name="duration_minutes" value={formData.duration_minutes} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="numeric" className={errors.duration_minutes ? 'error' : ''} placeholder="60" min="0" />
              {errors.duration_minutes && <span className="error-message">{errors.duration_minutes}</span>}
            </div>

            <div className="form-group full-width">
              <label htmlFor="description">Description</label>
              <textarea id="description" name="description" value={formData.description} onChange={handleChange} placeholder="Description détaillée de la prestation..." rows="3" />
            </div>

            <div className="form-group full-width">
              <label className="checkbox-label">
                <input type="checkbox" name="labor_included" checked={formData.labor_included} onChange={handleChange} />
                <span className="checkbox-text">Temps inclus</span>
              </label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">Annuler</button>
            <button type="submit" disabled={loading} className="btn-primary">{loading ? 'Création...' : 'Créer Prestation'}</button>
          </div>
        </form>
        <style>{`
          .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; }
          .modal-content { background: var(--admin-panel); color: var(--admin-text); border: 1px solid var(--admin-border); border-radius: 12px; width: 100%; max-width: 800px; max-height: 90vh; overflow-y: auto; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.35); }
          .modal-header { display: flex; justify-content: space-between; align-items: center; padding: 20px 20px 0 20px; border-bottom: 1px solid var(--admin-border); margin-bottom: 16px; }
          .modal-header h3 { margin: 0; font-size: 1.25rem; font-weight: 600; color: var(--admin-text); }
          .close-btn { background: none; border: 1px solid transparent; color: var(--admin-muted); cursor: pointer; padding: 6px; border-radius: 6px; transition: all .2s ease; }
          .close-btn:hover { background: rgba(255,255,255,0.06); border-color: var(--admin-border); color: var(--admin-text); }
          .quick-service-form { padding: 20px; }
          .form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px,1fr)); gap: 16px; margin-bottom: 16px; }
          .form-group { display: flex; flex-direction: column; gap: 6px; }
          .form-group label { font-weight: 500; color: var(--admin-text); font-size: .9rem; }
          .form-group input, .form-group select, .quick-service-form textarea { padding: 12px; border: 1px solid var(--admin-border); background: var(--admin-panel-2); color: var(--admin-text); border-radius: 8px; font-size: .9rem; transition: border-color .2s ease, box-shadow .2s ease; }
          .form-group input:focus, .form-group select:focus, .quick-service-form textarea:focus { outline: none; border-color: var(--admin-accent); box-shadow: 0 0 0 3px rgba(79,70,229,0.20); }
          .error-message { color: #ef4444; font-size: .8rem; }
          .full-width { grid-column: 1 / -1; }
          .form-actions { display: flex; justify-content: flex-end; gap: 10px; padding-top: 16px; border-top: 1px solid var(--admin-border); }
          .btn-secondary { background: var(--admin-panel-2); color: var(--admin-text); border: 1px solid var(--admin-border); padding: 10px 16px; border-radius: 8px; cursor: pointer; }
          .btn-secondary:hover { background: rgba(255,255,255,0.06); }
          .btn-primary { background: var(--admin-accent); color: #fff; border: none; padding: 10px 16px; border-radius: 8px; cursor: pointer; }
          .btn-primary:disabled { opacity: .6; cursor: not-allowed; }
          @media (max-width: 640px) { .modal-content { width: 95vw; } }
        `}</style>
      </div>
    </div>
  );
};

export default QuickServiceForm;
